var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4103_27618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5866 26.394H0.000976562V29H11.5866V26.394Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0014 29.0002L27.4257 26.197C26.4644 21.562 20.7597 19.7878 18.8843 18.9004C17.0089 18.0125 17.2841 15.3509 17.2841 15.3509C18.3096 13.7178 19.0075 12.3353 19.4815 11.2057C20.0726 10.1798 20.4264 8.99826 20.4721 7.73329C20.4875 7.55393 20.4854 7.46215 20.4854 7.46215C20.4849 3.37827 17.2425 0.0668945 13.2432 0.0668945C9.24384 0.0668945 6.00195 3.37827 6.00195 7.46215C6.00195 7.86545 6.04149 8.25774 6.1026 8.64269L6.0949 8.64373C6.1026 8.68831 6.11493 8.73394 6.12263 8.77957C6.14574 8.91068 6.17347 9.03969 6.20274 9.16923C6.20993 9.1986 6.21763 9.22745 6.22482 9.25734C6.27772 9.47236 6.33831 9.68372 6.40918 9.89087C7.23801 12.4465 9.07695 14.8585 9.07695 14.8585H11.2979C12.9392 14.9571 13.2432 17.1256 13.2432 17.1256V29.0008H28.0009L28.0014 29.0002Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5866 21.7603H0.000976562V24.3657H11.5866V21.7603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5866 17.1255H0.000976562V19.7315H11.5866V17.1255Z",
    fill: "#FF892A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C28.3137 30 31 27.3137 31 24C31 20.6863 28.3137 18 25 18C21.6863 18 19 20.6863 19 24C19 27.3137 21.6863 30 25 30Z",
    fill: "#FF892A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8729 23.013L24.1911 25.719L28.2883 21.5128",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4103_27618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28.9333,
    fill: "white",
    transform: "translate(0.000976562 0.0668945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupSuccess);
export default __webpack_public_path__ + "static/media/signup-success.7a978a015d7bbf6a21e416e974ee765d.svg";
export { ForwardRef as ReactComponent };